/**
 * Module definition for publish module. The publish module manages
 * the application's top-level publish view (i.e., /publish).
 *
 * @module routes.publish
 */

angular.module('routes.publish', [
  'routes.publish.PublishController',
  'routes.publish.PublishPayloadResolver'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.publish', {
          url: '/publish/:caseId',
          templateUrl: 'routes/publish/publish.html',
          controller: 'PublishController',
          params: {
            caseId: { value: null, squash: true }
          },
          resolve: {
            publishPayload: [
              'PublishPayloadResolver',
              '$stateParams',
              'newmanPayload',
              function (PublishPayloadResolver, $stateParams, newmanPayload) {
                return new PublishPayloadResolver($stateParams, newmanPayload);
              }
            ]
          }
        }
      );
    }
  ]
);
